import TEXTS from './locale/texts';

export const makeMsisdnBeautiful = (msisdn) => {
  if (!msisdn || typeof msisdn !== 'string') {
    return null;
  }
  const msisdnOnlyDigits = msisdn.replace(/[^0-9]/g, '');
  if (msisdnOnlyDigits.length < 11) {
    return null;
  }
  return '+7 '.concat(msisdnOnlyDigits.slice(1, 4))
  .concat(' ')
  .concat(msisdn.slice(4, 7))
  .concat(' ')
  .concat(msisdn.slice(7, 9))
  .concat(' ')
  .concat(msisdn.slice(9, 11));
};

export const getOrDash = value => value || '-';

export const getLocalizedOrDash = (value, lang) => {
  if (value && value[lang]) {
    return value[lang];
  }
  return '-';
};

export const range = (n) => {
  const array = [];
  for (let i = 0; i < n; i++) {
    array.push(i);
  }
  return array;
};

export const intTo2CharString = (value) => {
  if (value < 10) {
    return `0${value}`;
  }
  return `${value}`;
};

export const toStringDateTime = (datetime) => {
  if (!datetime) {
    return null;
  }
  const date = new Date(datetime);
  return `${intTo2CharString(date.getDate())}/${intTo2CharString(
      date.getMonth() + 1)}/${date.getFullYear()} ${intTo2CharString(
      date.getHours())}:${intTo2CharString(date.getMinutes())}`;
};

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const grammarNumbers = (number, titles) => {
  const cases = [2, 0, 1, 1, 1, 2];
  number = Math.abs(number);
  return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
};

export const CAMPAIGN_STATUSES = (lang) => {
  return {
    DRAFT: {
      name: 'Черновик',
      text: TEXTS.campaignStatusDraft[lang],
      color: 'gold'
    },
    IN_QUEUE: {
      name: 'Запланировано',
      text: TEXTS.campaignStatusInQueue[lang],
      color: 'blue'
    },
    SENT: {
      name: 'Отправлено',
      text: TEXTS.campaignStatusSent[lang],
      color: 'green'
    },
    FINISHED: {
      name: 'Завершено',
      text: TEXTS.campaignStatusFinished[lang],
      color: 'purple'
    },
    SENDING: {
      name: 'В процессе',
      text: TEXTS.campaignStatusSending[lang],
      color: 'cyan'
    }
  }
};

export const HERMES_DETAILS_STATUSES = (lang) => {
  // all statuses
  // N - new message
  //
  // S - sent to provider
  //
  // D - delivered by provider
  //
  // E - expired
  //
  // H - scheduled
  //
  // F - failed
  //
  // U - undeliverable
  //
  // J - rejected
  //
  // I - invalid
  //
  // A - accepted
  return {
    Delivered: {
      name: 'Доставлено',
      text: TEXTS.campaignStatusDelivered[lang],
      color: 'green'
    },
    Failed: {
      name: 'Ошибка',
      text: TEXTS.campaignStatusFailed[lang],
      color: 'red'
    },
    Undeliverable: {
      name: 'Невозможно доставить',
      text: TEXTS.campaignStatusUndeliverable[lang],
      color: 'gold'
    },
    Expired: {
      name: 'Время истекло',
      text: TEXTS.campaignStatusExpired[lang],
      color: 'cyan'
    }
  }
};

export const countSmsSegments = (smsMessage, isAsciiArg) => {
  const ASCII_SEGMENT_LENGTH_IF_MULTIPLE = 153;
  const ASCII_SEGMENT_LENGTH_IF_SINGLE = 160;
  const NON_ASCII_SEGMENT_LENGTH_IF_MULTIPLE = 67;
  const NON_ASCII_SEGMENT_LENGTH_IF_SINGLE = 70;

  let _isAscii;

  const isAscii = (text) => {
    return text.length === new Blob([text]).size;
  };

  const segmentCount = (text) => {
    if (!text) return 0;

    if (isAsciiArg === undefined) {
      // checking with UTF-8 is handy, because it increases the byte length
      // when any non ASCII symbol (i.e. EURO sign, diacritics) is contained in the text
      _isAscii = isAscii(text);
    } else {
      // if there are params from file
      _isAscii = isAsciiArg;
    }

    const maxChars = _isAscii
      ? ASCII_SEGMENT_LENGTH_IF_SINGLE
      : NON_ASCII_SEGMENT_LENGTH_IF_SINGLE;

    const segmentLength = _isAscii
      ? ASCII_SEGMENT_LENGTH_IF_MULTIPLE
      : NON_ASCII_SEGMENT_LENGTH_IF_MULTIPLE;

    if (text.length <= maxChars) return 1;

    return text.length % segmentLength === 0
      ? text.length / segmentLength
      : parseInt(text.length / segmentLength)  + 1;
  };

  return segmentCount(smsMessage);
};

// localStorage helpers
export const getValueFromStorage = (key) => {
  return localStorage.getItem(key);
};

export const addToStorage = (key, value) => {
  localStorage.setItem(key, value);
};

export const removeFromStorage = (key) => {
  localStorage.removeItem(key);
};

export const clearStorage = () => {
  localStorage.clear();
};

export const hasInStorage = (key) => {
  return !!localStorage.getItem(key);
};
